import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

import {ContactService} from '../core/ecv-http-services/services/contact.service';
import {OwnerModel} from './owner.model';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {

  ownerForm: FormGroup;
  ownerModel: OwnerModel;


  constructor(private contactService: ContactService) {
    this.ownerModel = new OwnerModel();
  }

  ngOnInit() {
    this.getExpertOwner();
    this.createForm();
  }

  private getExpertOwner() {
    this.contactService.getExpertOwner().subscribe(
      response => {
        this.ownerModel = response;
      });
  }

  private createForm(): void {
    this.ownerForm = new FormGroup({
      'firstName': new FormControl(''),
      'lastName': new FormControl(''),
      'role': new FormControl(''),
      'mainPhone': new FormControl(''),
      'email': new FormControl('')
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/contact/contact.component.ts